import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs';

import { PermissionStoreModelEnum } from '@domain/profile';

import { RouteSegments } from '@shared/enums';

import { fromCore } from '@stores/core';

export const dashboardGuard: CanActivateFn = (_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(fromCore.selectInitialProfileHasBeenDetermined$).pipe(
    filter((hasBeenDetermined) => hasBeenDetermined),
    switchMap(() => {
      return store
        .select(
          fromCore.selectUserHasPermissions$([
            PermissionStoreModelEnum.VIEW_ICO_DASHBOARD,
            PermissionStoreModelEnum.VIEW_PARTICIPANT_DASHBOARD,
          ])
        )
        .pipe(
          map((hasPermissionToViewDashboardScreen) => {
            if (!hasPermissionToViewDashboardScreen)
              return router.createUrlTree([RouteSegments.Root, RouteSegments.Public, RouteSegments.PlatformOverview]);

            return true;
          })
        );
    })
  );
};
